import { useAuth } from '../lib/AuthContext'

const ROLE_LABEL = { admin: 'Admin', portero: 'Portero', cliente: 'Cliente' }

export default function Layout({ children }) {
  const { profile, signOut } = useAuth()
  return (
    <div className="app-shell">
      <header className="topbar">
        <div>
          <span className="brand">Lim<em>pack</em></span>
          {profile?.role && <span className="role-pill">{ROLE_LABEL[profile.role]}</span>}
        </div>
        <div className="nav">
          <span className="user">{profile?.nombre}</span>
          <button className="signout" onClick={signOut}>Salir</button>
        </div>
      </header>
      {children}
    </div>
  )
}
